import request from '@/request'

const part_url = '/message/visit/';


/**
 *更新访问量
 * @returns
 */
function addVisitCount() {
  let url = part_url + "addCount";
  return request.get(url, {});
}

export default {
  addVisitCount
}



// WEBPACK FOOTER //
// ./src/api/visit.js